import { useCallback, useRef, useState } from 'react';

import { useClient, useIsomorphicLayoutEffect } from '@lib/hooks'

export const useH5SubmitPosition = () => {
  const isPC = useClient();
  const divRef = useRef<HTMLDivElement>();
  const [isPosition, setIsPosition] = useState(false);
  const handleObserver = useCallback(([target]) => {
    if (target.intersectionRatio > 0) {
      setIsPosition(false)
      return
    }
    setIsPosition(true)
  }, [])
  useIsomorphicLayoutEffect(() => {
    if (isPC) return;
    const intersectionObserver = new IntersectionObserver(handleObserver, {
      threshold: [0, 0.5, 1]
    });
    intersectionObserver.observe(divRef.current);
    return () => {
      intersectionObserver.unobserve(divRef.current)
    }
  }, [isPC])
  return { divRef, isPosition }
}
